import { Filter } from '~commonInfra/utils/Filter';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '~src/httpClient/resources/ResourceQuery';
import { NamedItemKeys } from '~src/spacesPlatform/models/resourceParts';
import { Order } from '~src/spacesPlatform/models/sort/Order';

import { GetDestinationProjectsRequest, IGetDestinationProjectsResult } from '../ServerApi/requests/GetDestinationProjectsRequest';
import { IDestinationProject } from '../ServerApi/types/IDestinationProject';

export type DestinationProjectContentType = 'project' | 'workbook' | 'datasource' | 'database' | 'flow' | 'dataRole' | 'lens' | 'metric' | 'table' | 'virtualConnection' | 'predictiveModel' | 'simulation';

class DestinationProjectsResource {

  private fetcher = new WebClientListResourceFetcher(GetDestinationProjectsRequest, (result: IGetDestinationProjectsResult) => result.projects);

  public getQueryForSpecificSourceContentAndMatchText(
    contentType: DestinationProjectContentType,
    sourceIds: string[],
    matchText: string
  ): ResourceQuery<IDestinationProject> {
    return new ResourceQuery(this.fetcher)
      .withExtraParams({ 'contentType': contentType, 'sourceIds': sourceIds })
      .withFiltersAndOrder([Filter.search(matchText)], [Order.asc(NamedItemKeys.name)]);
  }
}

export const DestinationProjects = new DestinationProjectsResource();
